module.exports = __webpack_public_path__ + "build/img/logo.a219f1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = cH+4
// module chunks = 1